var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_cof.js
// module id = 338
// module chunks = 0